import "./widgets.css";
import React from "react";

const WidgetsButton = ({
  type = "button",
  text = "",
  max = "",
  placeholder = "",
  icon = null,
  variant = "dark",
  onClick,
  select = null,
  name = null,
  value = null,
  data = [],
  width = "400px",
  className,
}) => {
  return type == "select" ? (
    <select name={name} value={value} onChange={onClick}>
      {data?.map((row) => row)}
    </select>
  ) : type == "button" || type == "submit" ? (
    <button
      type={type}
      className={variant == "dark" ? "dark-btn" : "light-btn"}
      onClick={onClick}
      style={{paddingRight: text ? "10px" : "5px"}}
    >
      {icon} {text}
    </button>
  ) : (
    <input
      type={type}
      value={value}
      name={name}
      max={max}
      className={className ? className : "universal-input"}
      onChange={onClick}
      placeholder={placeholder}
      style={{ width: width }}
    />
  );
};

export default WidgetsButton;
